var _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFiPaymentSecurity48 = function SvgFiPaymentSecurity48(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "financail-money-payment-pay-hand",
    width: 34.006,
    height: 33.734,
    viewBox: "0 0 34.006 33.734",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M35.439,10.709h-.567V8.442a.567.567,0,0,0-.64-.561l-.493.062V5.608a.558.558,0,0,0-.221-.448.575.575,0,0,0-.487-.1L12.241,10.392l2.114-3.661a2.872,2.872,0,0,0,.374-1.411A2.834,2.834,0,0,0,9.442,3.9L2.385,16.128A2.819,2.819,0,0,0,2,17.55v7.011a2.791,2.791,0,0,0,.108.776L3.916,31.68H3.7a.567.567,0,0,0-.567.567v3.4a.567.567,0,0,0,.567.567H16.169a.567.567,0,0,0,.567-.567v-3.4a.567.567,0,0,0-.567-.567V30.257a3.967,3.967,0,0,0-1.162-2.811l-.873-.867h21.3a.567.567,0,0,0,.567-.567V11.276A.567.567,0,0,0,35.439,10.709Zm-1.7-1.621v1.621H21.423ZM32.605,6.34V8.1L18.544,9.944ZM15.6,35.08H4.267V32.813H15.6Zm-3.355-8.853a.518.518,0,0,0,.125.181l-.006.006L14.2,28.251a2.8,2.8,0,0,1,.833,2.006V31.68H5.095L3.2,25.031a1.881,1.881,0,0,1-.062-.47V17.55a1.653,1.653,0,0,1,.232-.85L10.428,4.464a1.7,1.7,0,0,1,2.942,1.7l-2.624,4.545H9.368a.567.567,0,0,0-.567.567v11.9a.576.576,0,0,0,.351.527.567.567,0,0,0,.623-.136l5-5.169a1.7,1.7,0,0,1,2.873.878c.011.113.023.227.028.317a1.737,1.737,0,0,1-.5,1.2L12.366,25.61a.567.567,0,0,0-.119.618Zm22.625-.782H14.134l3.6-3.593a5.611,5.611,0,0,0,4.67,2.46A5.668,5.668,0,1,0,17,16.961a2.853,2.853,0,0,0-3.032.646l-4.03,4.171V11.843H34.872ZM18.765,19.1a2.849,2.849,0,0,0-.771-1.485,4.547,4.547,0,1,1,.487,3.282,3.047,3.047,0,0,0,.329-1.315C18.8,19.426,18.788,19.279,18.765,19.1Z",
    transform: "translate(-2 -2.48)",
    fill: "#0d47a1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M36.7,30.1a.567.567,0,0,1-.567-.567H35a1.7,1.7,0,0,0,1.134,1.6V31.8h1.134V31.13a1.7,1.7,0,0,0-.567-3.3.567.567,0,1,1,.567-.567H38.4a1.7,1.7,0,0,0-1.134-1.6V25H36.134v.671a1.7,1.7,0,0,0,.567,3.3.567.567,0,0,1,0,1.134Z",
    transform: "translate(-16.297 -12.236)",
    fill: "#0d47a1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M19.134,22.762a2.275,2.275,0,0,0,1.628-1.628h1.206V20h-1.7a.567.567,0,0,0-.567.567A1.134,1.134,0,0,1,18.567,21.7a.567.567,0,0,0-.567.567v1.7h1.134Z",
    transform: "translate(-8.932 -10.07)",
    fill: "#0d47a1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M53.834,23.762v1.206h1.134v-1.7A.567.567,0,0,0,54.4,22.7a1.134,1.134,0,0,1-1.134-1.134A.567.567,0,0,0,52.7,21H51v1.134h1.206A2.275,2.275,0,0,0,53.834,23.762Z",
    transform: "translate(-23.229 -10.503)",
    fill: "#0d47a1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M53.267,37.4A1.134,1.134,0,0,1,54.4,36.267a.567.567,0,0,0,.567-.567V34H53.834v1.206a2.275,2.275,0,0,0-1.628,1.628H51v1.134h1.7A.567.567,0,0,0,53.267,37.4Z",
    transform: "translate(-23.229 -16.135)",
    fill: "#0d47a1"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFiPaymentSecurity48, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fi-payment-security-48.16a6a3f7.svg";
export { ForwardRef as ReactComponent };